






























import { Component, Vue, Watch } from "vue-property-decorator";
import consts from "../../consts";

import ParrotWithGlasses from "@/assets/images/parrot/ParrotWithGlasses.svg?inline";

import { source, refreshAxiosCancelToken } from "@/store/actions";
import { getDomain } from "@/auth";
import { Action } from "vuex-class";
import amplitude from "amplitude-js";

@Component({
  components: {
    ParrotWithGlasses,
  },
})
export default class InitAssessment extends Vue {
  @Action private resetState: any;

  private $amplitude: any;

  private created() {
    // Setup amplitude
    // source.cancel();
    // let domain = getDomain(window.location.href) as string | undefined;
    // this.$cookies.remove("ORAI_AUTH", "/", domain);
    // this.$cookies.remove(consts.currentLearnerTeam, "/", domain);
    // localStorage.clear();
    // this.resetState();
    // refreshAxiosCancelToken();
    // amplitude.getInstance().init(consts.amplitudeKey, "", {
    //   saveEvents: true,
    //   includeUtm: true,
    //   includeReferrer: true,
    // });
    // this.$amplitude = amplitude.getInstance();
  }

  private gotoNext() {
    try {
      this.$amplitude.logEvent("baselineAssessment");
    } catch (error) {
      console.log("amplitude", error);
    }
    this.$emit("gotoNext");
  }
}
